/** @module Apparel/ProductSize/ProductSizesRenderer */
define([
	"dojo/_base/declare",
	"./_SizesRenderer"
], function(declare,_SizesRenderer) {

	return declare(_SizesRenderer, {
		/**
		 * @override
		 * Always allow copying
		 */
		canCopy: function(ctxCopy, h) {
			return true;
		},

		/**
		 * @override
		 * To paste, the product must use the same size range
		 */
		canPaste: function(ctxCopy, ctxPaste, h) {
			const fromProduct = ctxCopy.getNode();
			const fromProductAttributes = ctxCopy.cache.get(fromProduct.Attributes);
			const toProduct = ctxPaste.getNode();
			const toProductAttributes = ctxPaste.cache.get(toProduct.Attributes);

			return toProductAttributes.ActualSizeRange == fromProductAttributes.ActualSizeRange;
		},

		/**
		 * Return size range node where sizes came from
		 * @param {Context} ctx
		 * @return {Node | null}
		 */
		getSizeRange: function(ctx) {
			const {cache} = ctx;
			const product = ctx.getNode();
			if (!product) {
				return null;
			}
			const attributes = cache.get(product.Attributes);
			return cache.get(attributes.ActualSizeRange);
		}
	});
});
